import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BoloLogo from '@/components/base/BoloLogo';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Reports', path: 'https://theboloreport.substack.com/', external: true },
    { name: 'About', path: '/about' }
  ];

  const handleCategoriesClick = () => {
    setMobileOpen(false);
    const el = document.getElementById('categories');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#categories';
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#272727] border-b border-[#e9eae4]/10' : 'bg-[#272727]/95'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <BoloLogo className="h-11 w-auto" variant="dark" />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) =>
              link.external ? (
                <a
                  key={link.name}
                  href={link.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#e9eae4]/80 hover:text-[#e9eae4] text-sm font-medium tracking-wide transition-colors whitespace-nowrap cursor-pointer font-barlow"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.name}
                  to={link.path}
                  className={`text-sm font-medium tracking-wide transition-colors whitespace-nowrap cursor-pointer font-barlow ${
                    location.pathname === link.path
                      ? 'text-[#e9eae4]'
                      : 'text-[#e9eae4]/80 hover:text-[#e9eae4]'
                  }`}
                >
                  {link.name}
                </Link>
              )
            )}
            <button
              onClick={handleCategoriesClick}
              className="text-[#e9eae4]/80 hover:text-[#e9eae4] text-sm font-medium tracking-wide transition-colors whitespace-nowrap cursor-pointer bg-transparent border-none font-barlow"
            >
              Categories
            </button>
            <a
              href="https://theboloreport.substack.com/subscribe?utm_source=menu&simple=true&next=https%3A%2F%2Ftheboloreport.substack.com%2F"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#4d4d31] text-[#e9eae4] px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#3d3d25] transition-all whitespace-nowrap cursor-pointer font-barlow tracking-wide"
            >
              Subscribe
            </a>
          </div>

          <button
            className="md:hidden text-[#e9eae4] cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#272727] border-t border-[#e9eae4]/10 px-6 py-6 space-y-4">
          {navLinks.map((link) =>
            link.external ? (
              <a
                key={link.name}
                href={link.path}
                target="_blank"
                rel="noopener noreferrer"
                className="block text-[#e9eae4]/80 hover:text-[#e9eae4] text-base font-medium tracking-wide transition-colors cursor-pointer font-barlow"
                onClick={() => setMobileOpen(false)}
              >
                {link.name}
              </a>
            ) : (
              <Link
                key={link.name}
                to={link.path}
                className="block text-[#e9eae4]/80 hover:text-[#e9eae4] text-base font-medium tracking-wide transition-colors cursor-pointer font-barlow"
                onClick={() => setMobileOpen(false)}
              >
                {link.name}
              </Link>
            )
          )}
          <button
            onClick={handleCategoriesClick}
            className="block text-[#e9eae4]/80 hover:text-[#e9eae4] text-base font-medium tracking-wide transition-colors cursor-pointer bg-transparent border-none font-barlow w-full text-left"
          >
            Categories
          </button>
          <a
            href="https://theboloreport.substack.com/subscribe?utm_source=menu&simple=true&next=https%3A%2F%2Ftheboloreport.substack.com%2F"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-[#4d4d31] text-[#e9eae4] px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#3d3d25] transition-all whitespace-nowrap cursor-pointer font-barlow tracking-wide text-center"
          >
            Subscribe
          </a>
        </div>
      )}
    </nav>
  );
}
